export default "__VITE_ASSET__az0dFe44__"